import {acceptCustomerOffer} from "@project/sdk/sales";
import {AcceptCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function acceptCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.acceptCustomerOffer,
    mutationFn: async (id: string) =>
      AcceptCustomerOfferResponse.parse(await acceptCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
